import { call } from "redux-saga/effects";
import actions from "../constants/rtoRequestApprovalsActions";
import constants from "../constants/constants";
import { getDataFromAPI } from "../utils/sagas";
import { getToken } from "../utils/worker";
import urls from "../api/urls";

export function* getRtoRequestListWorker({ data }) {
  const { hubId, cpId, awbNumber, requestStatus, page, limit } = data || {};
  const params = new URLSearchParams();
  if (hubId) params.set("hubId", String(hubId));
  if (cpId) params.set("cpId", String(cpId).trim());
  if (awbNumber) params.set("awbNumber", String(awbNumber).trim());
  if (requestStatus) {
    params.set("requestStatus", requestStatus);
  }
  params.set("page", String(page || 1));
  params.set("limit", String(limit || 10));

  const url = `${urls.RTO_REQUEST_HUB}?${params.toString()}`;
  const authToken = getToken();
  const reqParams = {
    url,
    successAction: actions.GET_RTO_REQUEST_LIST_SUCCESS,
    errorAction: actions.GET_RTO_REQUEST_LIST_ERROR,
    params: { authToken },
  };

  yield call(
    getDataFromAPI,
    reqParams,
    constants.HTTP_METHODS.GET,
    constants.HTTP_REQ_DEFAULT_HEADERS,
    true,
    false
  );
}

export function* updateRtoRequestStatusWorker({ data }) {
  const authToken = getToken();
  const reqParams = {
    url: urls.RTO_REQUEST_ACTION,
    successAction: actions.UPDATE_RTO_REQUEST_STATUS_SUCCESS,
    errorAction: actions.UPDATE_RTO_REQUEST_STATUS_ERROR,
    params: {
      ...data,
      authToken,
    },
  };

  const headers = {
    ...constants.HTTP_REQ_DEFAULT_HEADERS,
    "Content-Type": "application/json",
  };

  yield call(
    getDataFromAPI,
    reqParams,
    constants.HTTP_METHODS.PATCH,
    headers,
    true,
    false
  );
}
